import type { PlanId } from './plans.types';

export const planIds = {
  earlyAdopter: 4,
  shelter: 9,
} as const satisfies Record<string, PlanId>;
